export function buildWordBuildPreviewAttempt(round, questionId, answer) {
  const isEnglish = round?.lesson?.code === 'ENGLISH';
  const currentWord = round?.current_word;
  if (!round?.preview || !currentWord || String(currentWord.question_id) !== String(questionId)) {
    throw new Error('Preview kelime bilgisi bulunamadı.');
  }

  const correct = String(answer) === String(currentWord.correct_answer);
  const wrongCount = Number(round.preview_wrong_count || 0) + (correct ? 0 : 1);
  if (!correct) {
    return {
      round_completed: false,
      attempt_result: { correct: false },
      round: {
        ...round,
        preview_wrong_count: wrongCount,
        current_word: {
          ...currentWord,
          attempt_count: Number(currentWord.attempt_count || 0) + 1,
        },
      },
    };
  }

  const completedWordCount = Number(round.completed_word_count || 0) + 1;
  const firstAttemptCorrectCount = Number(round.preview_first_attempt_correct_count || 0)
    + (Number(currentWord.attempt_count || 0) === 0 ? 1 : 0);
  const questionCount = Number(round.question_count || 3);
  if (completedWordCount >= questionCount) {
    return {
      round_completed: true,
      attempt_result: { correct: true },
      summary: {
        preview: true,
        task_type: 'word_build',
        completed_word_count: completedWordCount,
        question_count: questionCount,
        wrong_count: wrongCount,
        first_attempt_correct_count: firstAttemptCorrectCount,
        rounds_remaining: 1,
        next_prompt: isEnglish ? 'Great job, you completed 3 words!' : 'Harika, 3 kelimeyi tamamladın!',
        locale: isEnglish ? 'en' : 'tr',
      },
    };
  }

  const nextWord = round.preview_words?.[completedWordCount];
  if (!nextWord) throw new Error('Sıradaki preview kelimesi bulunamadı.');
  return {
    round_completed: false,
    attempt_result: { correct: true },
    round: {
      ...round,
      completed_word_count: completedWordCount,
      preview_wrong_count: wrongCount,
      preview_first_attempt_correct_count: firstAttemptCorrectCount,
      current_word: nextWord,
    },
  };
}
